import * as ActionTypes from './PhotographerActionTypes';
import moment from 'moment';
import InitialState from './PhotographerInitialState';
import { assign } from '../../shared/Assign';
import * as types from '../photographerCalendars/actions/ActionTypes';

export default function photographerReducer(
    state: any = InitialState.photographers,
    action: { type: string; viewModel: any; userResult: any; result?: any }
) {
    let newState: any;
    switch (action.type) {
        case ActionTypes.ADD_PHOTOGRAPHER_SUCCESS:
            newState = assign({}, state);
            newState.list = [...newState.list, assign({}, action.userResult)];
            return newState;
        case ActionTypes.LOAD_NEW_PHOTOGRAPHER_SUCCESS:
            newState = assign({}, state);
            newState.modal = assign({}, state.modal);
            newState.modal.imageEditorFirms = action.viewModel.imageEditorFirms;
            newState.modal.sellers = action.viewModel.sellers;
            newState.modal.regions = action.viewModel.regions;
            newState.modal.agreements = action.viewModel.agreements;
            newState.modal.products = action.viewModel.products;
            newState.modal.availableLanguages = action.viewModel.availableLanguages;
            return newState;
        case ActionTypes.LOAD_PHOTOGRAPHERS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.userResult;
            return newState;
        case ActionTypes.GET_EDIT_PHOTOGRAPHER_SUCCESS:
            newState = assign({}, state);
            newState.modal = assign({}, state.modal);
            newState.edit = assign({}, state.edit);
            newState.modal.imageEditorFirms = action.viewModel.imageEditorFirms;
            newState.modal.blockedForFirms = action.viewModel.blockedForFirms;
            newState.modal.sellers = action.viewModel.sellers;
            newState.modal.regions = action.viewModel.regions;
            newState.modal.agreements = action.viewModel.agreements;
            newState.edit.photographer = action.viewModel.photographer;
            newState.edit.photographer.description = action.viewModel.presentation.description;
            newState.edit.photographer.instagramLink = action.viewModel.presentation.instagramLink;
            newState.modal.products = action.viewModel.products;
            newState.modal.availableLanguages = action.viewModel.availableLanguages;
            newState.modal.workingHours = action.viewModel.workingHours;
            newState.modal.workingHours.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });
            newState.modal.workingHours.scandphotosWorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });
            return newState;
        case ActionTypes.UPDATE_PHOTOGRAPHER_SUCCESS:
            newState = assign({}, state);
            newState.list = [
                ...state.list.filter((x: any) => x.id !== action.userResult.id),
                assign({}, action.userResult)
            ];
            return newState;
        case ActionTypes.LOAD_PHOTOGRAPHERS_SUCCESS:
            newState = assign({}, state);
            newState.list = action.userResult;
            return newState;
        case ActionTypes.GET_PHOTOGRAPHER_CALENDAR_SUCCESS:
            newState = assign({}, state);
            newState.calendar = action.result;
            newState.calendar.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });
            newState.calendar.scandphotosWorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
            });
            return newState;
        case types.DELETE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            newState = assign({}, state);
            if (newState.calendar) {
                newState.calendar.items = newState.calendar.items.filter(
                    (x) => x.id !== action.result.id
                );
            }
            return newState;
        case types.UPDATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            newState = assign({}, state);
            if (newState.calendar) {
                let c = newState.calendar.items.filter((x) => x.id !== action.result.id);
                action.result.editable = true;
                c.push(action.result);
                newState.calendar.items = c;
            }
            return newState;
        case types.CREATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            newState = assign({}, state);
            if (newState.calendar) {
                if (!newState.calendar.items) {
                    newState.calendar.items = [];
                }
                action.result.item.editable = true;
                if (action.result.id) {
                    action.result.item.id = action.result.id;
                }
                newState.calendar.items.push(action.result.item);
            }
            return newState;
        case ActionTypes.CREATE_CUBICASA_CONNECTION_SUCCESS:
            newState = assign({}, state);

            (newState.edit.photographer.cubiCasaConnected = true),
                (newState.edit.photographer.cubiCasaId = action.result.cubiCasaId);
            newState.edit.photographer.cubiCasaStatus = action.result.cubiCasaStatus;
            newState.edit.photographer.cubiCasaRole = action.result.cubiCasaRole;

            return newState;
        case ActionTypes.UPDATE_PHOTOGRAPHER_WORKING_HOURS_SUCCESS:
            newState = assign({}, state);

            newState.calendar.se360WorkingHours = action.result.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
                return x;
            });

            newState.calendar.scandphotosWorkingHours = action.result.scandphotosWorkingHours.map(
                (x) => {
                    x.start = moment(x.start, 'HH:mm:ss').toDate();
                    x.end = moment(x.end, 'HH:mm:ss').toDate();
                    return x;
                }
            );

            newState.modal.workingHours.se360WorkingHours = action.result.se360WorkingHours.map(
                (x) => {
                    x.start = moment(x.start, 'HH:mm:ss').toDate();
                    x.end = moment(x.end, 'HH:mm:ss').toDate();
                    return x;
                }
            );

            newState.modal.workingHours.scandphotosWorkingHours =
                action.result.scandphotosWorkingHours.map((x) => {
                    x.start = moment(x.start, 'HH:mm:ss').toDate();
                    x.end = moment(x.end, 'HH:mm:ss').toDate();
                    return x;
                });

            return newState;

        default:
            return state;
    }
}
